import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import jwtEncode from "jwt-encode";
import "./App.css";
import Header from "./Components/Layout/Header";
import Sidebar from "./Components/Layout/Sidebar";
import AppRouter from "./Pages/AppRouter";
import { saveConfig, saveLandingConfig } from "./Store/slice/configSlice";
import { UNO_URL, applicationId } from "./env";
import { myApplicationList, setTags } from "./Store/slice/applicationSlice";
import FullScreenLoader from "./Components/FullScreenLoader/fullScreenLoader";
import { saveEventUser, saveUserData } from "./Store/slice/userSlice";

function App() {
  const path = window.location.pathname;
  const [sideBar, setSideBar] = useState(window.innerWidth <= 767);
  const dispatch = useDispatch();
  const [homePage, setHomePage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [defaultRoute, setDefaultRoute] = useState(null);
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);

  const checkLoggedStatus = (config, landingConfigData) => {
    localStorage.clear();
    sessionStorage.clear();
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };

    if (path.startsWith("/play/") || path.startsWith("/invite/")) {
      setSideBar(true);
      setLoading(false);
      return;
    }

    if (landingConfigData.visibleSections.includes("home") && path === "/") {
      setDefaultRoute("/");
      setSideBar(true);
      setLoading(false);
      return;
    }

    const token = jwtEncode(payload, "");
    window.location.href = `${config.redirectUri}?referrer=${token}`;
  };

  const getConfiguration = async () => {
    setLoading(true);
    await axios
      .get(`${UNO_URL}/api/application/configuration/${applicationId}`)
      .then((response) => {
        const data = response.data.data.data;
        //  data["API_URL"] = 'http://localhost:3333';
        //  data["UNO_URL"] = UNO_URL;
        dispatch(saveConfig({ data }));
        getXrLandingDetails({ config: data });
        getTagLists(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getXrLandingDetails = async ({ config }) => {
    let { data } = await axios.get(`${config.UNO_URL}/api/application/landing/configuration/${config.applicationId}`, {
      headers: {
        Authorization: `Bearer `,
      },
    });

    let landingConfigData = {
      landingConfig: data?.data?.landingConfig || null,
      visibleSections: data?.data?.visibleSections || [],
    };

    dispatch(saveLandingConfig(landingConfigData));
    getUserDetail(config, landingConfigData);
  };

  const getTagLists = async (config) => {
    try {
      const moduleTags = await axios.get(`${config.UNO_URL}/api/tag/list/${config.moduleFilterId}`, {
        headers: { Authorization: `Bearer ` },
      });
      const moduleFilterList = moduleTags.data || [];
      dispatch(setTags(moduleFilterList));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchApplication = async (token, config) => {
    try {
      var { data } = await axios.get(`${config.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDetail = async (config, landingConfigData) => {
    try {
      let referrerFind = false;
      let navigateRedirectUri = null;
      let referrerToken = null;
      const urlParams = new URLSearchParams(window.location.search);
      const _tokenParam = urlParams.get("referrer");

      if (_tokenParam) {
        const decoded = jwtDecode(_tokenParam);
        referrerToken = decoded.token;
        localStorage.setItem("token", referrerToken);
        navigateRedirectUri = decoded.redirectUri;
        referrerFind = true;
      }

      referrerToken = referrerToken || localStorage.getItem("token");

      let { data } = await axios.get(`${config.UNO_URL}/api/user/me`, {
        headers: {
          Authorization: `Bearer ${referrerToken}`,
        },
      });

      const { token, user } = data.data;
      localStorage.setItem("token", token);
      dispatch(saveUserData({ token, user }));
      fetchApplication(token, config);
      getChannelUsersList(config, token);

      // if(path === "/"){
      if (referrerFind) {
        if (navigateRedirectUri.startsWith("/invite/") || navigateRedirectUri.startsWith("/play/")) {
          setDefaultRoute(navigateRedirectUri);
        } else if (landingConfigData.visibleSections.includes("home")) {
          setDefaultRoute("/");
        } else {
          setDefaultRoute(`/dashboard/${user.uuid}`);
        }
      }
      // else if(landingConfigData.visibleSections.includes("home")){
      //   setDefaultRoute("/");
      // }
      // }

      if (path === "/" || path.startsWith("/play/") || path.startsWith("/invite/")) {
        setSideBar(true);
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
      checkLoggedStatus(config, landingConfigData);
    }
  };

  const getChannelUsersList = async (config, token) => {
    try {
      let { data } = await axios.get(`${config.UNO_URL}/api/resource/userListByChannel`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      dispatch(saveEventUser(data?.data));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getConfiguration();
  }, []);

  return (
    <>
      {loading ? (
        <FullScreenLoader loading={loading} />
      ) : (
        <>
          <Router>
            <div className={`App ${homePage ? "home" : ""}`}>
              <Header sideBar={sideBar} setSideBar={setSideBar} setHomePage={setHomePage} />
              {isLoggedIn && <Sidebar sideBar={sideBar} setSideBar={setSideBar} />}
              <div className={sideBar ? "main-content sideactive" : "main-content"}>
                <AppRouter setSideBar={setSideBar} defaultRoute={defaultRoute} />
              </div>
            </div>
          </Router>
        </>
      )}
    </>
  );
}

export default App;
